import { confirmDialog } from "./HtmlHelper";

const BUNDLE_SRC_RE = /\/static\/js\/main\.[^"']+\.js/;

const getBundleSrc = (html) => {
  const match = html.match(BUNDLE_SRC_RE);
  return match ? match[0] : null;
};

// CRA hashes the main JS bundle filename per build (main.<hash>.js). Polling
// index.html for that filename lets us detect a new production deploy even
// if some layer between the browser and the server still caches the page,
// and prompt the user to reload instead of them seeing a stale UI forever.
export const startVersionWatcher = (intervalMs = 5 * 60 * 1000) => {
  if (process.env.NODE_ENV !== "production") return;

  const currentBundle = getBundleSrc(document.documentElement.outerHTML);
  if (!currentBundle) return;

  let notifiedBundle = null;

  const checkForNewVersion = async () => {
    try {
      const res = await fetch(`/index.html?_=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;
      const html = await res.text();
      const latestBundle = getBundleSrc(html);
      if (
        latestBundle &&
        latestBundle !== currentBundle &&
        latestBundle !== notifiedBundle
      ) {
        notifiedBundle = latestBundle;
        confirmDialog(
          "A new version of this app is available. Reload now to get the latest updates?",
          () => window.location.reload()
        );
      }
    } catch (e) {
      // network hiccup - just retry on the next interval
    }
  };

  setInterval(checkForNewVersion, intervalMs);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkForNewVersion();
  });
};
